import React from "react";
import "./header.scss";
import { useNavigate } from "react-router-dom";

const Header2 = () => {
  const navigate = useNavigate();
  return (
    <div className="navbar">
      <ul>
        <li onClick={() => navigate("/aboutus")}>About Us</li>
        <li onClick={() => navigate("/")}>
          <div className="logo">{/* <img src={logo} alt="logo" /> */}</div>
          <div className="name"></div>
        </li>
        <li onClick={() => navigate("/faq")}>FAQs</li>
      </ul>
    </div>
  );
};

export default Header2;
